import React from 'react'
import Wrapper from '../helpers/Wrapper'
import SectionHead from '../components/SectionHead'
import Product from '../components/Product/Product';
import { useWishlists } from '../hooks/useWishlists';
import AnimatePage from '../components/AnimatePage';
import { ChangePageTitle } from '../helpers/ChangeTitle';

function Wishlist() {
    ChangePageTitle("Wishlist")
    const { data, isLoading } = useWishlists();

    return (
        <AnimatePage>
            <div className='w-full relative mt-8'>
                <Wrapper>
                    <SectionHead
                        title={"Wishlist"}
                        description={`Save your favorite items to your wishlist for easy access and 
                    future shopping`}
                    />

                    {/* Main No products were added to the wishlist page.  */}

                    {/* Products */}
                    <div className="grid grid-cols-2 mt-8 gap-3 sm:gap-8 lg:grid-cols-4 xl:grid-cols-5">
                        {
                            data?.map((product, i) => (
                                <div key={i}>
                                    <Product data={product} loading={isLoading} />
                                </div>
                            ))
                        }
                    </div>
                </Wrapper>
            </div>
        </AnimatePage>
    )
}

export default Wishlist